import React from 'react'
import { Box, Typography, SvgIcon } from '@mui/material'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

interface UserDisplayProps {
    userDisplayName: string
    onClick: (event: React.MouseEvent<HTMLElement>) => void
    variant: 'flyin' | 'cleartrip'
}

const UserDisplay: React.FC<UserDisplayProps> = ({ userDisplayName, onClick, variant }) => {
    const isDisabled = false

    if (variant === 'cleartrip') {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    gap: 0.5,
                    px: 1.5,
                    py: 0.75,
                    borderRadius: 1,
                    '&:hover': { bgcolor: 'grey.100' },
                    transition: 'background-color 0.2s'
                }}
                onClick={onClick}
            >
                <PersonOutlineIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
                <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: 14,
                        color: 'text.secondary',
                        maxWidth: 120,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {userDisplayName}
                </Typography>
            </Box>
        )
    }

    return (
        <Box
            sx={{
                display: { xs: 'none', sm: 'none', md: 'flex' },
                alignItems: 'center',
                cursor: 'pointer',
                ml: 1,
                pointerEvents: isDisabled ? 'none' : 'auto',
                opacity: isDisabled ? 0.7 : 1
            }}
            onClick={onClick}
        >
            <PersonOutlineIcon sx={{ fontWeight: 300, fontSize: 20, mr: 0.5 }} />
            <Typography
                sx={{
                    fontWeight: 500,
                    fontSize: 15,
                    maxWidth: 120,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap'
                }}
            >
                {userDisplayName}
            </Typography>
            {!isDisabled && (
                <SvgIcon sx={{ fontSize: 17, ml: 0.5 }}>
                    <svg width="17" height="17" viewBox="0 0 24 24">
                        <path d="M7 10l5 5 5-5" stroke="#1a2a3a" strokeWidth="1.3" fill="none" />
                    </svg>
                </SvgIcon>
            )}
        </Box>
    )
}

export { UserDisplay }
export type { UserDisplayProps }
